import styled from 'styled-components';
import { COLORS } from '@/styles/colors';
import { bodySmall, caption } from '@/styles/typography';
import BellSvg from './images/BellIcon.svg?react';

export const BellIcon = styled(BellSvg)`
  width: 20px;
  height: 20px;
`;

export const Badge = styled.span`
  position: absolute;
  top: -6px;
  right: -6px;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 9px;
  background: ${COLORS.red[450]};
  color: ${COLORS.white};
  font-size: 11px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const NotificationsHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 16px 12px;
  border-bottom: 1px solid ${COLORS.grey[400]};

  .link {
    ${caption};
    border: 0;
    background: none;
    cursor: pointer;
    font-weight: 600;
    color: ${COLORS.green[600]};
  }
`;

export const NotificationsList = styled.div`
  display: flex;
  flex-direction: column;
  width: 360px;
  max-width: calc(100vw - 32px);
  max-height: 420px;
  overflow: auto;
`;

export const NotificationRow = styled.button<{ $unread?: boolean }>`
  ${bodySmall};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  width: 100%;
  padding: 12px 16px;
  border: 0;
  border-bottom: 1px solid ${COLORS.grey[200]};
  background: ${({ $unread }) => ($unread ? '#FFF8F6' : COLORS.white)};
  text-align: left;
  cursor: pointer;

  &:hover {
    background: ${COLORS.grey[100]};
  }
`;
